import { render, staticRenderFns } from "./RiskListHeader.vue?vue&type=template&id=4bdb6e9b&scoped=true&"
import script from "./RiskListHeader.vue?vue&type=script&lang=ts&"
export * from "./RiskListHeader.vue?vue&type=script&lang=ts&"
import style0 from "./RiskListHeader.vue?vue&type=style&index=0&id=4bdb6e9b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdb6e9b",
  null
  
)

export default component.exports